const DEFAULT_RETURN_PATH = '/settings/plan-billing';

// Stripe substitutes {CHECKOUT_SESSION_ID} at redirect time; the return page
// reads it back as `checkout_session_id` to drive the post-checkout settle
// state. `returnPath` lets the entry point choose where checkout returns to.
export function buildCheckoutSuccessUrl(returnPath: string = DEFAULT_RETURN_PATH): string {
    const separator = returnPath.includes('?') ? '&' : '?';
    return `${window.location.origin}${returnPath}${separator}checkout_session_id={CHECKOUT_SESSION_ID}`;
}

export function buildCheckoutCancelUrl(returnPath: string = DEFAULT_RETURN_PATH): string {
    return `${window.location.origin}${returnPath}`;
}
